<template>
    <div class="wish-list">
        <div class="fav_title_con">
            <div class="fav_title">我的收藏</div>
            <div class="fav_search_con">
                <input class="fav_input" type="text" v-model="searchVal" placeholder="请输关键词">
                <img class="search_icon" @click="queryData" src="../../assets/search-icon.png">
            </div>
        </div>
        <div v-if="cruiseList.length > 0" class="wishlist__container">
            <div v-for="(item, index) in cruiseList" :key="item.id" class="list-item">
                <div class="list-item-img-con">
                    <img class="list-item-img" :src="item.pcImage">
                </div>
                <div class="list-item-con">
                    <div class="item-title-con">
                        <div class="item-title float-left">{{interceptChar(item.cruiseName, 64)}}</div>
                    </div>
                    <div class="item-info-text">
                        {{item.routeDays}}天{{item.routeDays - 1}}晚
                        <span style="display: inline-block; margin-left: 18px;">{{item.shipCNName}}</span>
                    </div>
                    <div class="item-info-text">
                        <div class="float-left">
                            {{item.sailDateBegin}} - {{item.sailDateEnd}}
                        </div>
                        <div class="item-more-date" @click="getMore(item)">
                            <img class="float-left" style="margin-right: 5px" src="../../assets/icon-date.png">
                            <div class="float-left">更多日期</div>
                        </div>
                    </div>
                    <div style="width: 450px; max-height: 70px;">
                        <div class="list-search-input-tag-con">
                            <a v-for="tag in item.tags" :key="tag.tagId" :href="tag.tagLink ? tag.tagLink : 'javascript: void(0)'" class="list-search-input-tag" v-bind:class="{hide: !tag.tagIsShow, hot: tag.tagIsHot}">
                                {{tag.tagType}}
                                <div class="tool-tip">{{tag.tagDescription}}</div>
                            </a>
                        </div>
                    </div>
                    <div class="btns_con">
                        <div class="act_con">
                            <div class="act_item blue find_similar" @click="findSimilarities(item)">
                                <img src="../../assets/same_icon.png">
                                <span>找相似</span>
                            </div>
                            <div class="act_item delete_wish" @click="handleDelete(item, index)">
                                <img src="../../assets/del_icon.png">
                                <span>删除</span>
                            </div>
                        </div>
                        <div class="item-btn-con" v-if="!item.netAmount || item.netAmount <= 0">
                            <div class="item-null">
                                <img src="https://resource.rcclchina.com.cn/cruiseSearch/pc/soldout.png">
                            </div>
                        </div>
                        <div class="item-btn-con" v-else>
                            <div class="item-btn" @click="book(item)">立即预订</div>
                            <div class="item-price">
                                <div>{{item.isRow ? '单船票' : (numberToChinese(item.priceGuestNumber) + '人房' + (item.isnrpPrice ? '早订特惠价' : '优惠价'))}}(含税)</div>
                                <span style="color: #ffa70d">￥</span>
                                <span style="color: #ffa70d; font-size: 24px">{{item.taxablePrice}}</span>
                                /人起 &gt;
                                <div v-if="!item.isRow">平均每晚￥{{item.amountPerNight}}/人起</div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <!-- 为空 -->
        <div v-else class="fav_emp_con">
            <div class="fav_emp_box">
                <img src="../../assets/empty-icon.png">
                <div class="fav_emp_text">这怎么能行，快来添加您的美好旅行计划吧！</div>
                <router-link tag="div" to="/Rccl.Cruise/CruiseSearch/Search" class="fav_emp_btn">
                    搜索及添加心仪的航线
                </router-link>
            </div>
        </div>

        <!-- 页码 -->
        <div v-if="cruiseList.length > 0" class="pagination-container">
            <pagination
                :total="total"
                :size="pageSize"
                :current="pageIndex"
                placement="left"
                @on-change="changePage"
            ></pagination>
        </div>

        <!-- 更多日期 -->
        <more-sail-date-popup
            :isShow="isShowMore"
            :cruise="cruiseByMore"
            :moreSailDatePopupClose="popupClose"
            :rowCruiseSearchHandler="handleSearch"
        ></more-sail-date-popup>

    </div>
</template>

<script>
    import Pagination from '@/components/User/Pagination'
    import api from '@/api'
    import { numberToChinese, interceptChar } from '@/utilities/tools'
    import MoreSailDatePopup from '@/components/Cruise/MoreSailDatePopup'

    export default {
        name: 'WishList',
        components: {
            Pagination,
            MoreSailDatePopup
        },
        data: () => {
            return {
                token: '',
                pageIndex: 1,
                pageSize: 5,
                total: 0,
                preAllCruise: [],
                allCruise: [],
                cruiseList: [],
                searchVal: '',
                isShowMore: false,
                cruiseByMore: {}
            }
        },
        beforeMount () {
            this.init()
        },
        methods: {
            async init () {

                await this.initPage()

            },
            async initPage () {
                this.token = this.$store.state.user.userToken
                this.$loading.show()
                const data = await this.getStoredCruiseList()
                this.$loading.hide()
                if (!data) return
                //初始化数据
                this.preAllCruise = data.cruises
                this.allCruise = this.preAllCruise
                this.cruiseList = this.showList(this.pageIndex)
                this.total = data.count
            },
            numberToChinese (num) {
                return numberToChinese(num)
            },
            interceptChar (str, num) {
                return interceptChar(str, num)
            },
            findSimilarities (item) {
                let shipCodes = item.shipCode
                let departureCodes = (item.routeEvents.find(item => item.day === 1)).harborCode
                let destinationCodes = ''
                let destinationArr = []
                item.routeEvents.map((ele, i) => {
                    if (i != 0 && i != item.routeEvents.length - 1) {
                        if (ele.harborCode && ele.harborCode.indexOf('CRU_')<0
                            && destinationArr.indexOf(ele.harborCode)<0
                            && departureCodes.indexOf(ele.harborCode)<0) {
                                destinationArr.push(ele.harborCode)
                            }
                    }
                })
                destinationCodes = destinationArr.toString()
                let sailDays = 6
                if (item.routeDays - 1 == 4) {
                    sailDays = 4
                } else if (item.routeDays - 1 == 5) {
                    sailDays = 5
                }
                if (item.isRow) {
                    window.open(`/Rccl.Cruise/CruiseSearch/SearchRow?shipCodes=${shipCodes}&departureCodes=${departureCodes}&destinationCodes=${destinationCodes}&sailDays=${sailDays}`)
                } else {
                    window.open(`/Rccl.Cruise/CruiseSearch/Search?shipCodes=${shipCodes}&departureCodes=${departureCodes}&destinationCodes=${destinationCodes}&sailDays=${sailDays}`)
                }
            },
            book (item) {
                if (item.isRow) {
                    this.$router.push(`/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.sailDate}&cruiseId=${item.cruiseId}`)
                } else {
                    this.$router.push(`/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.sailDate}`)
                }
            },
            getMore (item) {
                this.isShowMore = true
                this.cruiseByMore = item
                document.body.style.overflow = 'hidden'
            },
            popupClose () {
                this.isShowMore = false
                document.body.style.overflow = 'auto'
            },
            handleSearch () {},
            showList (pageIndex) {
                return this.allCruise.slice((pageIndex - 1) * this.pageSize, pageIndex * this.pageSize)
            },
            async searchByKey (key) {
                const keywords = key.trim()
                const result = []
                const regExp = new RegExp(`${keywords}`, 'i')
                this.preAllCruise.map(item => {
                    if (regExp.test(item.cruiseName)) {
                        result.push(item)
                    } else if (regExp.test(item.shipCNName)) {
                        result.push(item)
                    } else {
                        const tags = item.tags
                        const tagNames = tags.map(tag => {
                            return tag.tagName
                        })
                        if (tagNames.length > 0 && regExp.test(tagNames.toString())) {
                            result.push(item)
                        }
                    }
                })
                return result
            },
            async handleDelete (item, index) {
                const that = this
                this.$confirm.show('确认删除该条航线吗', {
                    confirmCallBack: async function () {
                        that.$loading.show()
                        const flag = await that.deleteWishList(item.cruiseId)
                        that.$loading.hide()
                        if (flag) {
                            that.cruiseList.splice(index, 1)
                            if(that.cruiseList.length<=0){
                              await that.initPage()
                              that.pageIndex = that.pageIndex - 1
                              that.cruiseList = that.showList(that.pageIndex)
                            }
                        } else {
                            that.$alert.show('删除失败！')
                        }
                    },
                    cancelCallBack: function () {},
                })
            },
            async changePage (page) {
                this.pageIndex = page
                this.cruiseList = this.showList(page)
            },
            async queryData () {
                this.pageIndex = 1
                this.allCruise = this.searchVal === ''
                    ? this.allCruise = [...this.preAllCruise]
                    : await this.searchByKey(this.searchVal)
                this.cruiseList = this.showList(this.pageIndex)
                this.total = this.allCruise.length
            },
            async getStoredCruiseList () {
                const { errMsg, data, success } = await api.cruise.getWishList({
                    Offset: 0,
                    Limit: 1000
                })
                if (success) {
                    return data
                } else {
                    window.console.log(errMsg)
                }
            },
            async deleteWishList (cruiseId) {
                const { errMsg, success } = await api.cruise.deleteWishList({
                    userName: this.token,
                    cruiseId
                })
                if (success) {
                    return true
                } else {
                    window.console.log(errMsg)
                    return false
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .fav_title_con {
        overflow: hidden;
        margin-bottom: 10px;
        .fav_title {
            float: left;
            font-size: 16px;
            color: #282b2c;
            margin-top: 8px;
        }
        .fav_search_con {
            float: right;
            width: 247px;
            height: 36px;
            background-color: #ffffff;
            border: solid 1px #d3dadd;
            .fav_input {
                float: left;
                border: none;
                height: 32px;
                margin: 1px 0;
                font-style: normal;
                padding-left: 8px;
            }
            .search_icon {
                float: right;
                width: 24px;
                height: 23px;
                margin-top: 6px;
                margin-right: 8px;
                cursor: pointer;
            }
        }
    }

    .list-item {
        background-color: #fff;
        margin-bottom: 10px;
        padding: 10px;
        overflow: hidden;
        position: relative;
        .list-item-img-con {
            width: 237px;
            height: 239px;
            position: relative;
            float: left;
        }
        .list-item-tag {
            width: 108px;
            height: 37px;
            background: url('../../assets/bg-tag.png') no-repeat 100%;
            position: absolute;
            top: 10px;
            left: -5px;
            .list-item-tag-text {
                height: 28px;
                line-height: 28px;
                color: #fff;
                text-align: center;
            }
        }
        .list-item-bottom {
            width: 100%;
            padding: 10px 0;
            background: linear-gradient(to bottom, rgba(40, 43, 44, 0.3), #282b2c);
            position: absolute;
            bottom: 0;
            left: 0;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
        }
        .list-item-con {
            margin-left: 18px;
            width: 640px;
            float: left;
            .item-title {
                max-width: 605px;
                margin-top: 5px;
                font-weight: 600;
            }
            .item-title-con {
                font-size: 22px;
                line-height: 30px;
                color: #282b2c;
                overflow: hidden;
            }
            .like-con {
                font-size: 12px;
                color: #747d80;
                float: right;
            }
            .item-tag-con {
                margin-top: 6px;
                overflow: hidden;
                .item-tag-item {
                    margin-right: 20px;
                    float: left;
                    line-height: 21px;
                    height: 21px;
                }
            }
            .item-info-text {
                font-size: 14px;
                color: #282b2c;
                margin-top: 6px;
                overflow: hidden;
                font-weight: 400;
                .item-more-date {
                    color: #006ab9;
                    margin-left: 8px;
                    float: left;
                    line-height: 16px;
                    margin-top: 0px;
                    cursor: pointer;
                }
            }
            .list-search-input-tag-con {
                float: left;
                .tooltip {
                    &.in {
                        width: auto;
                    }
                    .tooltip-inner {
                        background: #54A3DE;
                        color: white;
                        padding: 5px 10px;
                        max-width: 280px;
                        text-align: left;
                    }
                    .tooltip-arrow {
                        border-bottom-color: #54A3DE;
                    }
                }
            }
            .list-search-input-tag {
                display: block;
                position: relative;
                padding: 0 20px;
                height: 25px;
                line-height: 25px;
                background-color: #e5f4ff;
                border-radius: 13px;
                color: #0073bb;
                font-size: 12px;
                text-decoration: none;
                float: left;
                margin-left: 10px;
                margin-top: 7px;
                font-weight: 400;
                cursor: pointer;
                text-align: center;
                min-width: 88px;
                &.hide {
                    display: none;
                }
                &.hot {
                    background: #febc10;
                    color: #fff;
                }
                &:hover {
                    .tool-tip {
                        display: block;
                    }
                }
                .tool-tip {
                    display: none;
                    position: absolute;
                    z-index: 11;
                    float: left;
                    left: 50%;
                    top: 32px;
                    padding: 0 12px;
                    background-color: #54a3de;
                    border-radius: 4px;
                    box-shadow: 0 0 8px rgba(0,0,0,0.2);
                    color: #fff;
                    line-height: 25px;
                    white-space: nowrap;
                    -webkit-transform: translateX(-50%);
                    -moz-transform: translateX(-50%);
                    -o-transform: translateX(-50%);
                    -ms-transform: translateX(-50%);
                    transform: translateX(-50%);
                    &::after {
                        content: "";
                        display: block;
                        position: absolute;
                        left: 50%;
                        top: -7px;
                        width: 0;
                        height: 0;
                        border-left: #54a3de solid 5px;
                        border-top: transparent solid 5px;
                        border-bottom: transparent solid 5px;
                        -webkit-transform: translateX(-50%) rotateZ(-90deg);
                        -moz-transform: translateX(-50%) rotateZ(-90deg);
                        -o-transform: translateX(-50%) rotateZ(-90deg);
                        -ms-transform: translateX(-50%) rotateZ(-90deg);
                        transform: translateX(-50%) rotateZ(-90deg);
                    }
                }
            }
            .item-btn-con {
                position: relative;
                margin-top: 14px;
                float: right;
                .item-group-price {
                    font-size: 14px;
                    color: #282b2c;
                    height: 50px;
                    border: solid 1px #fbc500;
                    padding: 4px 16px;
                    float: left;
                    font-weight:400;
                    span {
                        vertical-align:middle;
                        line-height:40px;
                    }
                }
                .item-price {
                    font-size: 14px;
                    color: #282b2c;
                    position: absolute;
                    top: -79px;
                    right: 0;
                    font-weight: 400;
                    text-align: right;
                }
            }
            .item-btn {
                width: 228px;
                height: 50px;
                line-height: 50px;
                background-color: #fbc500;
                font-size: 22px;
                color: #282b2c;
                text-align: center;
                float: left;
                font-weight: 500;
                cursor: pointer;
            }
            .list-search-input-tag-con {
                margin-top: 3px;
                width: 430px;
            }
            .list-search-input-tag {
                margin-left: 0px;
                margin-right: 5px;
                float: left;
            }
        }
        .btns_con {
            position: absolute;
            bottom: 10px;
            width: 677px;
        }
    }
    .act_con {
        overflow: hidden;
        margin-top: 30px;
        float: left;
        .act_item {
            float: left;
            font-size: 14px;
            margin-right: 15px;
            color: #747d80;
            font-weight: 400;
            img {
                display: inline-block;
                vertical-align: middle;
                width: 14px;
                height: 14px;
                margin-right: 3px;
            }
            span {
                display: inline-block;
                vertical-align: middle;
            }
        }
    }
    .fav_emp_con {
        position: relative;
        width: 100%;
        height: 350px;
        .fav_emp_box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            .fav_emp_text {
                font-size: 16px;
                color: #a2adb1;
                margin-top: 6px;
                margin-bottom: 12px;
            }
            .fav_emp_btn {
                width: 210px;
                height: 32px;
                background-color: #ffffff;
                border-radius: 16px;
                border: solid 1px #54a3de;
                line-height: 32px;
                margin: 0 auto;
                font-size: 16px;
                color: #54a3de;
                cursor: pointer;
            }
        }
    }
    .or_line_con {
        overflow: hidden;
        margin-top: 20px;
        margin-bottom: 18px;
        .rec_head_con {
            position: relative;
            padding: 11px 0;
            .line {
                width: 100%;
                height: 1px;
                background-color: #d3dadd;
            }
            .rec_title {
                width: 110px;
                position: absolute;
                top: 0;
                left: calc(50% - 60px);
                font-size: 22px;
                line-height: 22px;
                color: #000000;
                text-align: center;
            }
            .rec_rel_con {
                position: absolute;
                top: -2px;
                right: 0;
                padding-left: 6px;
                .rel_icon {
                    width: 14px;
                    margin-left: 5px;
                    margin-top: -2px;
                }
                .rel_text {
                    font-size: 14px;
                    color: #747d80;
                }
            }
        }
        .rec_con {
            overflow: hidden;
            .rec_item {
                float: left;
                margin-top: 20px;
                margin-right: 18px;
                overflow: hidden;
                width: 457px;
                background-color: #fff;
                padding: 10px;
                .rec_img {
                    float: left;
                    width: 155px;
                    height: 155px;
                    background-size: cover;
                    .rec_info_con {
                        float: left;
                        margin-left: 17px;
                        color: #282b2c;
                        .rec_title {
                            width: 265px;
                            font-size: 16px;
                            font-weight: 600;
                            line-height: 24px;
                            color: #006ab9;
                            margin-top: 10px;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            -webkit-box-orient: vertical;
                        }
                        .ship_time {
                            font-size: 16px;
                            padding: 5px 0px;
                            line-height: 16px;
                            margin: 2px 0;
                            .line_label {
                                display: inline-block;
                                margin-right: 16px;
                            }
                        }
                        .rec_pic {
                            color: #ffa70d;
                            font-size: 14px;
                            margin-top: 7px;
                        }
                    }
                }
            }
        }
    }
    .float-left {
        float: left;
    }
    .blue {
        color: #54a3de !important;
    }

    .find_similar {
        cursor: pointer;
    }

    .delete_wish {
        cursor: pointer;
    }

    .list-item-img {
        width: 100%;
        height: 100%;
    }

    .or_line_con {
        margin: 20px;
    }

    .item-null {
        position: absolute;
        right: -4px;
        top: -31px;
        transform: rotate(15deg);
    }

    .pagination-container{
        padding: 20px 0;
    }
</style>
